import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const MyCourses = createAsyncThunk('lecture-courses', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-lecturer/my-courses`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MyStudents = createAsyncThunk('lecture-students', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-lecturer/my-students`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerProfile = createAsyncThunk('lecture-profile', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-lecturer/profile`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const EditProfile = createAsyncThunk('profile-edit', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}dua-lecturer/profile-edit`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const UpdateProfile = createAsyncThunk('profile-update', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}dua-lecturer/profile-update`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type lecturerPortalState = {
  errors: any
}

const initialState: lecturerPortalState = {
  errors: '',
}

export const lecturerPortalSlice = createSlice({
  name: 'lecturer-portal',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
  },
})

export const { reset } = lecturerPortalSlice.actions
export default lecturerPortalSlice.reducer
